import type {NextPage} from 'next'
import NavigationLayout from "../core-web/components/core/templates/NavigationLayout";
import ApplicationLayout, {ApplicationColumn} from "../core-web/components/core/templates/ApplicationLayout";
import EmailConfiguration from "../core-web/components/core/preview/EmailConfiguration";
import EmailPreview from "../core-web/components/core/preview/EmailPreview";
import {ApplicationProvider} from "../core-web/context/ApplicationContext/ApplicationContext";
import {CREATE_PAGE_META, customTitle} from "../core-web/constants";
import {DEFAULT_RENDER_CONFIG} from "@app/core-app/app/data/profile";


const Create: NextPage = () => {
  return <NavigationLayout hideNavigation
    pageTitle={customTitle("Create email from notion page")}
    description={CREATE_PAGE_META}
  >
    <ApplicationProvider initialValue={{
      configuration: {
        pageLink: "",
        pageConfig: {
          ...DEFAULT_RENDER_CONFIG,
          // Images
          downloadImages: false,

        }
      },
      result: {
        inProgress: false,
        error: null,
        alerts: [],
        body: null
      }
    }}>
      <ApplicationLayout className={"pt-6 bg-gray-100"}>
        <ApplicationColumn className={"mb-12 px-6 lg:mb-0 lg:w-2/5"}>
          <EmailConfiguration/>
        </ApplicationColumn>
        <ApplicationColumn className={"mb-12 lg:mb-0 lg:w-3/5 lg:pr-6 lg:pb-6 lg:h-full"}>
          <EmailPreview className={"h-[750px] lg:h-full"}/>
        </ApplicationColumn>
      </ApplicationLayout>
    </ApplicationProvider>
  </NavigationLayout>
}

export default Create
